import { Page } from '@/components/layout/page/page.tsx'

export const WelcomeMessagesPageSkeleton = () => {
  return (
    <Page>
      <div className="flex flex-col gap-[40px]">
        <div className="mb-2 h-[100px] w-full animate-pulse rounded-lg bg-skeleton" />
        <div className="mb-2 h-[100px] w-full animate-pulse rounded-lg bg-skeleton" />
        <div className="mb-2 h-[400px] w-full animate-pulse rounded-lg bg-skeleton" />
      </div>
    </Page>
  )
}
